import { gql, TypedDocumentNode } from "@apollo/client";

import {
  SetAccountPreferenceMutation,
  SetAccountPreferenceMutationVariables,
} from "./SetAccountPreference.generated";

const SET_ACCOUNT_PREFERENCE: TypedDocumentNode<
  SetAccountPreferenceMutation,
  SetAccountPreferenceMutationVariables
> = gql`
  mutation SetAccountPreference(
    $key: String!
    $value: GenericScalar!
  ) {
    setAccountPreference(key: $key, value: $value) {
      ok
    }
  }
`;

export default SET_ACCOUNT_PREFERENCE;
